// extracted by mini-css-extract-plugin
export default {"customePhoneNumberInput":"customePhoneNumberInput_styles_customePhoneNumberInput__a0rPk","requiredSing":"customePhoneNumberInput_styles_requiredSing__Em7Mw"};